"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { createPortal } from "react-dom";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
import MemeDropTraits from "@/components/memes/drops/MemeDropTraits";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
import type { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
interface MemesWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const MemesWaveWinnersDrop: React.FC<MemesWaveWinnersDropProps> = t0 => {
  const $ = _c(139);
  const {
    winner,
    wave,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== winner.drop.metadata) {
    t2 = winner.drop.metadata?.find(_temp)?.data_value || "Artwork Title";
    $[2] = winner.drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const title = t2;
  let t3;
  if ($[4] !== winner.drop.metadata) {
    t3 = winner.drop.metadata?.find(_temp2)?.data_value || "This is an artwork submission for The Memes collection.";
    $[4] = winner.drop.metadata;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const description = t3;
  let t4;
  if ($[6] !== winner.drop.parts) {
    t4 = winner.drop.parts.at(0)?.media.at(0);
    $[6] = winner.drop.parts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const artworkMedia = t4;
  const rating = winner.drop.rating || 0;
  const isPositive = rating >= 0;
  const ratersCount = winner.drop.raters_count || 0;
  let creditType;
  let extendedDrop;
  let hasUserVoted;
  let isUserVoteNegative;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let userVote;
  if ($[8] !== artworkMedia || $[9] !== description || $[10] !== hasTouchScreen || $[11] !== isPositive || $[12] !== onDropClick || $[13] !== rating || $[14] !== title || $[15] !== touchHandlers || $[16] !== wave.voting?.credit_type || $[17] !== winner) {
    const topVoters = winner.drop.top_raters?.slice(0, 3) || [];
    creditType = WAVE_VOTING_LABELS[wave.voting?.credit_type as ApiWaveCreditType] || wave.voting?.credit_type || "votes";
    hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context?.rating !== 0;
    userVote = winner.drop.context_profile_context?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    let t20;
    if ($[38] !== winner.drop) {
      t20 = convertApiDropToExtendedDrop(winner.drop);
      $[38] = winner.drop;
      $[39] = t20;
    } else {
      t20 = $[39];
    }
    extendedDrop = t20;
    if ($[40] !== extendedDrop || $[41] !== onDropClick) {
      t18 = () => onDropClick(extendedDrop);
      $[40] = extendedDrop;
      $[41] = onDropClick;
      $[42] = t18;
    } else {
      t18 = $[42];
    }
    t19 = "touch-select-none tw-cursor-pointer tw-rounded-xl tw-transition-all tw-duration-300 tw-ease-out tw-w-full";
    t17 = "tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 desktop-hover:hover:tw-border-[#fbbf24]/20 tw-shadow-[0_0_15px_rgba(251,191,36,0.08)] tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden tw-bg-iron-950";
    t12 = "tw-flex tw-flex-col";
    t13 = touchHandlers;
    let t21;
    if ($[43] !== winner) {
      t21 = <WaveWinnersDropHeaderAuthorPfp winner={winner} />;
      $[43] = winner;
      $[44] = t21;
    } else {
      t21 = $[44];
    }
    let t22;
    if ($[45] !== winner.drop.author) {
      t22 = winner.drop.author?.level && <UserCICAndLevel level={winner.drop.author.level} size={UserCICAndLevelSize.SMALL} />;
      $[45] = winner.drop.author;
      $[46] = t22;
    } else {
      t22 = $[46];
    }
    let t23;
    if ($[47] !== winner.drop.author) {
      t23 = winner.drop.author?.handle ? <UserProfileTooltipWrapper user={winner.drop.author.handle ?? winner.drop.author.id}><Link href={`/${winner.drop.author?.handle ?? winner.drop.author?.id}`} onClick={_temp3} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${winner.drop.author?.handle ?? winner.drop.author?.id}`} onClick={_temp4} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author?.handle ?? winner.drop.author?.id}</span></Link>;
      $[47] = winner.drop.author;
      $[48] = t23;
    } else {
      t23 = $[48];
    }
    let t24;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <span className="tw-text-sm tw-text-iron-500">•</span>;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== winner.drop.created_at) {
      t25 = <WaveDropTime timestamp={winner.drop.created_at} />;
      $[50] = winner.drop.created_at;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    let t26;
    if ($[52] !== t22 || $[53] !== t23 || $[54] !== t25) {
      t26 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-flex-wrap -tw-mt-0.5">{t22}{t23}{t24}{t25}</div>;
      $[52] = t22;
      $[53] = t23;
      $[54] = t25;
      $[55] = t26;
    } else {
      t26 = $[55];
    }
    let t27;
    if ($[56] !== winner.place) {
      t27 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={winner.place} decisionTime={null} /></div>;
      $[56] = winner.place;
      $[57] = t27;
    } else {
      t27 = $[57];
    }
    let t28;
    if ($[58] !== t26 || $[59] !== t27) {
      t28 = <div className="tw-flex tw-flex-col tw-justify-between tw-h-12">{t26}{t27}</div>;
      $[58] = t26;
      $[59] = t27;
      $[60] = t28;
    } else {
      t28 = $[60];
    }
    let t29;
    if ($[61] !== t21 || $[62] !== t28) {
      t29 = <div className="tw-flex tw-gap-x-3">{t21}{t28}</div>;
      $[61] = t21;
      $[62] = t28;
      $[63] = t29;
    } else {
      t29 = $[63];
    }
    let t30;
    if ($[64] !== extendedDrop || $[65] !== hasTouchScreen) {
      t30 = !hasTouchScreen && <div className="tw-flex tw-items-start tw-flex-shrink-0"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
      $[64] = extendedDrop;
      $[65] = hasTouchScreen;
      $[66] = t30;
    } else {
      t30 = $[66];
    }
    if ($[67] !== t29 || $[68] !== t30) {
      t14 = <div className="tw-p-4 tw-pb-3 tw-border-b tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-white/5 tw-bg-iron-900/30"><div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t29}{t30}</div></div>;
      $[67] = t29;
      $[68] = t30;
      $[69] = t14;
    } else {
      t14 = $[69];
    }
    let t31;
    if ($[70] !== title) {
      t31 = <h3 className="tw-text-base tw-font-semibold tw-text-iron-100 tw-mb-0">{title}</h3>;
      $[70] = title;
      $[71] = t31;
    } else {
      t31 = $[71];
    }
    let t32;
    if ($[72] !== description) {
      t32 = <p className="tw-text-sm tw-text-iron-400 tw-mb-0 tw-line-clamp-2">{description}</p>;
      $[72] = description;
      $[73] = t32;
    } else {
      t32 = $[73];
    }
    if ($[74] !== t31 || $[75] !== t32) {
      t15 = <div className="tw-px-4 tw-pt-4 tw-pb-4"><div className="tw-space-y-1">{t31}{t32}</div></div>;
      $[74] = t31;
      $[75] = t32;
      $[76] = t15;
    } else {
      t15 = $[76];
    }
    if ($[77] !== artworkMedia) {
      t16 = artworkMedia && <div className="tw-flex tw-justify-center tw-bg-iron-950 tw-h-96"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
      $[77] = artworkMedia;
      $[78] = t16;
    } else {
      t16 = $[78];
    }
    t10 = "tw-p-4 tw-mt-4 tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-white/5 tw-bg-iron-900/30 tw-space-y-4";
    if ($[79] !== winner.drop) {
      t11 = <MemeDropTraits drop={winner.drop} />;
      $[79] = winner.drop;
      $[80] = t11;
    } else {
      t11 = $[80];
    }
    t8 = "tw-flex tw-items-center tw-flex-wrap tw-gap-x-4 tw-gap-y-2";
    const t33 = `tw-text-sm tw-font-bold ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
    let t34;
    if ($[81] !== rating) {
      t34 = formatNumberWithCommas(rating);
      $[81] = rating;
      $[82] = t34;
    } else {
      t34 = $[82];
    }
    let t35;
    if ($[83] !== t33 || $[84] !== t34) {
      t35 = <span className={t33}>{t34}</span>;
      $[83] = t33;
      $[84] = t34;
      $[85] = t35;
    } else {
      t35 = $[85];
    }
    let t36;
    if ($[86] !== creditType) {
      t36 = <span className="tw-text-sm tw-text-iron-500">{creditType} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
      $[86] = creditType;
      $[87] = t36;
    } else {
      t36 = $[87];
    }
    if ($[88] !== t35 || $[89] !== t36) {
      t9 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t35}{t36}</div>;
      $[88] = t35;
      $[89] = t36;
      $[90] = t9;
    } else {
      t9 = $[90];
    }
    t7 = "tw-flex tw-items-center tw-gap-2";
    t5 = "tw-flex tw-items-center -tw-space-x-2";
    t6 = topVoters.map(_temp6);
    $[8] = artworkMedia;
    $[9] = description;
    $[10] = hasTouchScreen;
    $[11] = isPositive;
    $[12] = onDropClick;
    $[13] = rating;
    $[14] = title;
    $[15] = touchHandlers;
    $[16] = wave.voting?.credit_type;
    $[17] = winner;
    $[18] = creditType;
    $[19] = extendedDrop;
    $[20] = hasUserVoted;
    $[21] = isUserVoteNegative;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = userVote;
  } else {
    creditType = $[18];
    extendedDrop = $[19];
    hasUserVoted = $[20];
    isUserVoteNegative = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t17 = $[29];
    t18 = $[30];
    t19 = $[31];
    t5 = $[32];
    t6 = $[33];
    t7 = $[34];
    t8 = $[35];
    t9 = $[36];
    userVote = $[37];
  }
  let t20;
  if ($[91] !== t5 || $[92] !== t6) {
    t20 = <div className={t5}>{t6}</div>;
    $[91] = t5;
    $[92] = t6;
    $[93] = t20;
  } else {
    t20 = $[93];
  }
  let t21;
  if ($[94] !== ratersCount) {
    t21 = formatNumberWithCommas(ratersCount);
    $[94] = ratersCount;
    $[95] = t21;
  } else {
    t21 = $[95];
  }
  const t22 = ratersCount === 1 ? "voter" : "voters";
  let t23;
  if ($[96] !== t22) {
    t23 = <span className="tw-text-iron-500 tw-font-normal">{t22}</span>;
    $[96] = t22;
    $[97] = t23;
  } else {
    t23 = $[97];
  }
  let t24;
  if ($[98] !== t21 || $[99] !== t23) {
    t24 = <span className="tw-text-iron-200 tw-font-semibold tw-text-sm">{t21}{" "}{t23}</span>;
    $[98] = t21;
    $[99] = t23;
    $[100] = t24;
  } else {
    t24 = $[100];
  }
  let t25;
  if ($[101] !== t20 || $[102] !== t24 || $[103] !== t7) {
    t25 = <div className={t7}>{t20}{t24}</div>;
    $[101] = t20;
    $[102] = t24;
    $[103] = t7;
    $[104] = t25;
  } else {
    t25 = $[104];
  }
  let t26;
  if ($[105] !== creditType || $[106] !== hasUserVoted || $[107] !== isUserVoteNegative || $[108] !== userVote) {
    t26 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{creditType}</span></span></div></div>;
    $[105] = creditType;
    $[106] = hasUserVoted;
    $[107] = isUserVoteNegative;
    $[108] = userVote;
    $[109] = t26;
  } else {
    t26 = $[109];
  }
  let t27;
  if ($[110] !== t25 || $[111] !== t26 || $[112] !== t8 || $[113] !== t9) {
    t27 = <div className={t8}>{t9}{t25}{t26}</div>;
    $[110] = t25;
    $[111] = t26;
    $[112] = t8;
    $[113] = t9;
    $[114] = t27;
  } else {
    t27 = $[114];
  }
  let t28;
  if ($[115] !== t10 || $[116] !== t11 || $[117] !== t27) {
    t28 = <div className={t10}>{t11}{t27}</div>;
    $[115] = t10;
    $[116] = t11;
    $[117] = t27;
    $[118] = t28;
  } else {
    t28 = $[118];
  }
  let t29;
  if ($[119] !== extendedDrop || $[120] !== hasTouchScreen || $[121] !== isActive || $[122] !== setIsActive) {
    t29 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[119] = extendedDrop;
    $[120] = hasTouchScreen;
    $[121] = isActive;
    $[122] = setIsActive;
    $[123] = t29;
  } else {
    t29 = $[123];
  }
  let t30;
  if ($[124] !== t12 || $[125] !== t13 || $[126] !== t14 || $[127] !== t15 || $[128] !== t16 || $[129] !== t28 || $[130] !== t29) {
    t30 = <div className={t12} {...t13}>{t14}{t15}{t16}{t28}{t29}</div>;
    $[124] = t12;
    $[125] = t13;
    $[126] = t14;
    $[127] = t15;
    $[128] = t16;
    $[129] = t28;
    $[130] = t29;
    $[131] = t30;
  } else {
    t30 = $[131];
  }
  let t31;
  if ($[132] !== t17 || $[133] !== t30) {
    t31 = <div className={t17}>{t30}</div>;
    $[132] = t17;
    $[133] = t30;
    $[134] = t31;
  } else {
    t31 = $[134];
  }
  let t32;
  if ($[135] !== t18 || $[136] !== t19 || $[137] !== t31) {
    t32 = <div onClick={t18} className={t19}>{t31}</div>;
    $[135] = t18;
    $[136] = t19;
    $[137] = t31;
    $[138] = t32;
  } else {
    t32 = $[138];
  }
  return t32;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(e_1) {
  return e_1.stopPropagation();
}
function _temp6(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle ?? voter.profile.id}`} onClick={_temp5} scroll={false} className="tw-transition-transform desktop-hover:hover:tw-translate-y-[-2px]" data-tooltip-id={`voter-${voter.profile.handle}-${voter.rating}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle}-${voter.rating}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}